import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { EColorBgText } from '@ucheba/utils/helpers/styles/variables'
import styled from 'styled-components'
import { EColorCardTitle, IBlockWithCardsList } from '../types'
import SC from '../base/BlockWithCards.styles'
import ButtonRegEvent from '../../ButtonRegEvent/desktop'

const { Block, Image } = SC

const GridSC = styled(Grid)`
  height: 100%;
`

const GridColSC = styled(GridCol)`
  display: flex;
  align-items: center;
  margin-right: 8px;
`

const BlockWithCardsList: FC<IBlockWithCardsList> = (props) => {
  const { title, items, button } = props
  return (
    <Block>
      <Spacing spacing='uxlarge' />

      {title && (
        <>
          <Heading h2={title} />

          <Spacing spacing='large' />
        </>
      )}

      <Grid spacing='small'>
        {items &&
          items.map((card, key) => (
            <GridCol key={key}>
              <GridSC as={Box} spacing='small' color={card.color}>
                <Grid spacing='uxsmall'>
                  {card.icon && (
                    <GridColSC width='auto'>
                      <Image src={card.icon} />
                    </GridColSC>
                  )}

                  <GridCol width='auto'>
                    {card.subTitle && (
                      <Text color={EColorBgText[card.color]}>{card.subTitle}</Text>
                    )}
                  </GridCol>
                </Grid>

                <Spacing spacing='usmall' />

                {card.title && (
                  <>
                    <Text
                      color={EColorCardTitle[card.color]}
                      fontSize='h3'
                      fontWeight='extrabold'
                    >
                      {card.title}
                    </Text>

                    <Spacing spacing='usmall' />
                  </>
                )}

                {card.text && <Text color={EColorBgText[card.color]}>{card.text}</Text>}
              </GridSC>
            </GridCol>
          ))}
      </Grid>

      {button && (
        <>
          <Spacing spacing='xlarge' />

          <ButtonRegEvent color={button.color} />
        </>
      )}
    </Block>
  )
}

export default memo(BlockWithCardsList)
